/* eslint-disable @typescript-eslint/no-unused-vars */
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Company } from "../companies/company";
import { Document } from "@models/documents/document";
import { Entity } from "../companies/entity";
import { EntityChangeData } from "../documents/entity-change-data";

export class AnnualChangeData extends EntityChangeData {
  static override readonly $type = 'AnnualStatement480';
  acnNumber: string;
  companyName: string;
  coverLetterId: string | null;
  coverLetterName: string;
  coverFileName: string;
  isDefaultCoverLetter: boolean;
  reviewDate: string;

  constructor(data: Partial<AnnualChangeData> = {}) {
    super(data);

    this.acnNumber = data.acnNumber ?? '';
    this.companyName = data.companyName ?? '';
    this.coverLetterId = data.coverLetterId ?? null;
    this.coverLetterName = data.coverLetterName ?? '';
    this.coverFileName = data.coverFileName ?? '';
    this.isDefaultCoverLetter = data.isDefaultCoverLetter ?? false;
    this.reviewDate = data.reviewDate ?? '';
  }

    override toDictionary(entity: Entity): { key: string; value: string; }[] {
    throw new Error("Method not implemented.");
  }
  override fillModal(modalRef: NgbModalRef, document: Document, actualCompany: Company): NgbModalRef {
    throw new Error("Method not implemented.");
  }
  override fillModalWithCompany(modalRef: NgbModalRef, company: Company, isEdit: boolean): NgbModalRef {
    throw new Error("Method not implemented.");
  }
}
